/** How long something has been running, as a bare duration: `45s`, `3m 5s`, `2h 10m`. */
export function formatElapsedSeconds(seconds: number): string {
  const totalSeconds = Math.max(0, Math.floor(seconds));
  if (totalSeconds < 60) {
    return `${totalSeconds}s`;
  }

  const totalMinutes = Math.floor(totalSeconds / 60);
  if (totalMinutes < 60) {
    const restSeconds = totalSeconds % 60;
    return restSeconds === 0 ? `${totalMinutes}m` : `${totalMinutes}m ${restSeconds}s`;
  }

  // Seconds are noise at this length.
  const hours = Math.floor(totalMinutes / 60);
  const restMinutes = totalMinutes % 60;
  return restMinutes === 0 ? `${hours}h` : `${hours}h ${restMinutes}m`;
}
